import React from "react";
import ReactDOM from "react-dom/client";
import "./scss/custom.scss";
import "./scss/index.scss";
import App from "./App";
import { unregister } from "./registerServiceWorker";
import config from "./aws-exports";
import { Amplify } from "aws-amplify";
const { aws_cognito_identity_pool_id, ...amplifyConfig } = config;
Amplify.configure(amplifyConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
unregister();
